module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Rheinhessen-216c4452b780d520490727dec52b446d.jpeg";